import { IApplicationState } from '../../types/redux';

export function selectDocumentTitle(state: IApplicationState): string {
  return state.seoData.title;
}
